import { 
    ACTUALIZAR_LIST_SISTEMA
  } from "./sistemaAction";

  const sistemaReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_SISTEMA: {
            return {
                ...state,
                sistemaList: action.payload
            }
        };

        

        default:
            return state;

    }
  }

  export default sistemaReducer;